module.exports = __webpack_public_path__ + "img/Artboard 1.bfe7c95a.png";